export default "__VITE_ASSET__BIhEEtLH__"